import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';
import { graphql } from 'react-relay';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type {
	preloadPendingRequestExistsQuery$data,
	preloadPendingRequestExistsQuery$variables,
} from './__generated__/preloadPendingRequestExistsQuery.graphql.ts';

const PreloadPendingRequestExistsQuery = graphql`
	query preloadPendingRequestExistsQuery(
		$accessRequestedAaid: String!
		$cloudId: ID!
		$contentId: ID!
	) {
		confluence_pendingRequestExists(
			accessRequestedAaid: $accessRequestedAaid
			cloudId: $cloudId
			contentId: $contentId
		) {
			isPendingAccessRequestExists
		}
	}
`;

export function preloadPendingRequestExists(
	contentId: string,
	cloudId: string,
	accessRequestedAaid: string,
): Promise<{
	data: preloadPendingRequestExistsQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<preloadPendingRequestExistsQuery$data, preloadPendingRequestExistsQuery$variables>({
		query: PreloadPendingRequestExistsQuery,
		variables: { accessRequestedAaid, cloudId, contentId },
	});
}
